import { produce } from 'immer'
import { State } from '../typings'
import { ServiceLocation } from '@user/store/entityLocations'

export type LoadRelatedAction = {
  type: 'loadRelated'
  payload: ServiceLocation[]
}

export const loadRelated = produce<State, [LoadRelatedAction['payload']]>(
  (draft, payload) => {
    draft.externalLocations = payload
    draft.matches = new Map()
  },
)
